import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "../../constants";
import { fetchCurrentUser, verify2fa } from "../../api";
import { AppContext } from "../../AppContext";

export default function Verify2fa() {
  const { username, setUsername, password, setPassword } =
    useContext<any>(AuthContext);

  const { setContext } = useContext(AppContext);

  const [localUsername, setLocalUsername] = useState<string>("");
  const [localPwd, setLocalPwd] = useState<string>("");

  const [code, setCode] = useState<string>("");
  const [verify2faError, setVerify2faError] = useState<string>("");

  const navigate = useNavigate();

  const navigateToHome = async () => {
    const user = await fetchCurrentUser();
    localStorage.setItem("user", JSON.stringify(user));
    setContext();
    navigate("/");
  };

  const verify2faMutation = useMutation<any>({
    mutationFn: () => verify2fa(localUsername, localPwd, code),
    onSuccess: (data) => {
      localStorage.setItem(ACCESS_TOKEN, data.access);
      localStorage.setItem(REFRESH_TOKEN, data.refresh);
      navigateToHome();
    },
    onError: (error: any) => {
      const err = error.response.data?.detail;
      if (err) {
        setVerify2faError(err);
      } else {
        setVerify2faError("Errore durante la verifica del codice.");
      }
    },
  });

  useEffect(() => {
    if (!username || !password) {
      navigate("/login");
    }

    setLocalUsername(username);
    setLocalPwd(password);
    setUsername("");
    setPassword("");
  }, []);

  return (
    <div
      style={{
        margin: "2rem auto 0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <p>Apri l'app di autenticazione e inserisci il codice temporaneo.</p>
      <form
        style={{
          margin: "0 auto",
          display: "flex",
          gap: "1rem",
          alignItems: "center",
        }}
      >
        <label>Codice temporaneo: </label>
        <input
          type="text"
          inputMode="numeric"
          maxLength={6}
          value={code}
          onChange={(e: any) => setCode(e.target.value)}
        />
        <button
          className="button_var1"
          onClick={(e: any) => {
            e.preventDefault();
            verify2faMutation.mutate();
          }}
        >
          Invia
        </button>
      </form>
      {verify2faMutation.isError && (
        <p style={{ color: "red" }}>{verify2faError}</p>
      )}
    </div>
  );
}
